import React from 'react';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Banner from "../lottie/banner2.json";
import Lottie from "./utils/Lottie";

const styles = theme => ({
    root: {

    },
    container: {
        width: '90%',
        margin: '0 auto',
        padding: '20px 0',
    },
    bannerImage: {
        width: '100%',
        height: 'auto',
    },
    heroContent: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
    },
    line1: {
        fontSize: '30px',
        fontWeight: '700',
        [theme.breakpoints.down('sm')]: {
            fontSize: '22px',
        },
    },
    line2: {
        fontSize: '18px',
        margin: '15px 0',
        [theme.breakpoints.down('sm')]: {
            fontSize: '16px',
        },
    },
    button: {
        backgroundColor: '#38A1F3',
        padding: '5px',
        width: '130px',
        fontSize: '13px'
    },
});

const HeroHome = (props) => {
    const { classes } = props;
    return (
        <section className={classes.container}>
            <Grid container spacing={32}>
                <Grid container item xs={12} sm={6} md={6} lg={6} justify="center">
                    <div className={classes.heroContent}>
                        <Typography variant="h5" className={classes.line1}>Web & Mobile App Development for your Business or Startup</Typography>
                        <Typography variant="body1" className={classes.line2}>Have a project for us, small or big, our team of experts will handle it for you. Click on the button below to start your first project</Typography>
                        <Button variant="contained" color="secondary" className={classes.button} onClick={() => {
                            const elmnt = document.getElementById("contact_us");
                            elmnt.scrollIntoView({ behavior: "smooth" });
                        }}>
                            Contact Now</Button>
                    </div>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                    {/* <img src={Banner} alt="Banner" className={classes.bannerImage} /> */}
                    <Lottie animationData={Banner} />
                </Grid>
            </Grid>
        </section>
    );
}

HeroHome.propTypes = {
    classes: PropTypes.object.isRequired
}

export default withStyles(styles)(HeroHome);